
export const TAB_NAMES = [
  'BY_MONTH',
  'BY_CATEGORY',
  'BY_PAYEE',
];
export const BY_MONTH = 0;
export const BY_CATEGORY = 1;
export const BY_PAYEE = 2;
